import { Link } from "react-router-dom";
import { Button } from "../shared/button";

export function PreparationFormat() {
  return (
    <div className="Wrapper">
      <div>
        <h2>Формат подготовки</h2>

        <p>
          Вы можете готовиться в мини-группе по полноценной программе или
          заниматься с преподавателем индиивдуально. Оба формата хороши, но у
          каждого есть свои преимущества.
        </p>

        <p>
          Мы поможем подобрать оптимальный способ обучения и ответим на все
          вопросы на бесплатной консультации.
        </p>

        <Link to={"/"}>
          <Button>
            <span>Записаться</span>
          </Button>
        </Link>
      </div>
    </div>
  );
}
